import Component from './invitation.vue'
export default Component
